<template>
  <div  class ="page page-onlinecourses-catalogue-editable" >
    <div class ="page-content">
      <div  class ="breadcrumb-wrapper" slot="breadcrumb">
        <el-breadcrumb separator="/" v-scoped>
            <el-breadcrumb-item>教学资源</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/teacher-book' }">数字资源</el-breadcrumb-item>
            <el-breadcrumb-item>视频详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="data-wrapper">
      <div class="video-wrapper">
          <iframe
          ref="iframeViewer"
          id="iframeViewer"
          :src="iframeUrl"
          :allowfullscreen="true"
        ></iframe>
      </div>
      <div class="content-wrapper">
          <div class="head-title">
              <span>{{this.data.name}}</span>
          </div>
          <div class="line">

          </div>
          <ul class="course-desc-list">
              <li class="row-flex">
                <span class="row-flex-prefix">所属年级：</span>
                <span class="row-flex-main">{{
                  gradeNameVal(data.grade,true)
                }}</span>
              </li>
              <li class="row-flex">
                <span class="row-flex-prefix">册次：</span>
                <span class="row-flex-main">{{
                  volumeNameVal(data.volume,true)
                }}</span>
              </li>
              <li class="row-flex">
                <span class="row-flex-prefix">单元：</span>
                <span class="row-flex-main">{{
                  unitNameVal(data.unit,true)
                }}</span>
              </li>
              <li class="row-flex" >
                <span class="row-flex-prefix">上传时间：</span>
                <span class="row-flex-main">{{
                  data.createTime
                }}</span>
              </li>
              <li class="row-flex" v-if="data.videoDes!=''">
                <span class="row-flex-prefix" >视频介绍：</span>
                <span class="row-flex-main">{{data.videoDes}}</span>
              </li>
              
            </ul>


      </div>
    </div>
    </div>
  </div>
</template>

<script>
import publicUrl from "@/assets/js/interface.js";
export default {
    components: {
    },
    data(){
        return {
            loadingCount:0,
            bodyStyle:{
                background:"none",
                padding:0
            },
            gradeList:[
                { value:'all', label:'全部' },
                { value:'k3', label:'三年级' },
                { value:'k4', label:'四年级' },
                { value:'k5', label:'五年级' },
                { value:'k6', label:'六年级' },
                { value:'k7', label:'七年级' },
                { value:'k8', label:'八年级' },
            ],
            unitList:[
                { value:'u1', label:'一单元' },
                { value:'u2', label:'二单元' },
                { value:'u3', label:'三单元' },
                { value:'u4', label:'四单元' },
                { value:'u5', label:'五单元' },
                { value:'u6', label:'六单元' },
            ],
            volumeList:[
                { value:'v1', label:'上册' },
                { value:'v2', label:'下册' },

            ],
            data:{
                    id:'',
                    name:'',
                    cover:'',
                    grade:'',
                    videoUrl:'',
                    videokey:'',
                    videoDes:'',
                    totalTime:'',
                    createUser:'',
                    createTime:'',
                    updateUser:'',
                    updateTime:''
                },
            videoId:'',
            iframeUrl:''
        
        }
    },
    methods:{
        //计算年级中文名称
        gradeNameVal(data,symbol){
            let str="";
            this.gradeList.forEach(item => {
                if(item.value==data){
                    str=item.label;
                    if(!symbol)str+="，"
                }
            });
            return str;
        },
        volumeNameVal(data){
            let str="";
            this.volumeList.forEach(item => {
                if(item.value==data){
                    str=item.label;
                }
            });
            return str;
        },
        unitNameVal(data){
            let str="";
            this.unitList.forEach(item => {
                if(item.value==data){
                    str=item.label;
                }
            });
            return str;
        },
        //加载数据
        loadTable(){
            this.loadingCount++;
            let _id=this.videoId
            this.$ajax.get(publicUrl.getVideoDetail,{params:{
                id:_id
            }}).then(res => {
                let data = this.$ajaxCheck(res);
                if(!data) return;
                this.data=data
                this.getVideoUrl(this.data.id)

            }).catch(err => {
                this.$ajaxError(err);
            }).finally(()=>{
                
            })
        },
           //获取播放凭证
           getVideoUrl(id){
            
            this.$ajax.get(publicUrl.getPlayAuth, {
            params: { id: id } ,
        }) .then((res) => {
            let data = this.$ajaxCheck(res);
            if (!data) return;
            this.iframeUrl = `https://component-pub.jsxfedu.com/document-viewer/index.html?format=m3u8&vid=${
                data.videoId || ""}&playauth=${data.playAuth ||
                ""}&encryptType=${data.encrypt ||0}`;
        }) .catch((err) => {
          this.$ajaxError(err);
          this.iframeUrl = `https://component-pub.jsxfedu.com/document-viewer/index.html?format=m3u8`

        }).finally(() => {
          this.loadingCount--;
        });
       
    },
},
    
    mounted(){
        this.videoId=this.$route.query.id || '';
        if(this.videoId)this.loadTable();
    },
    activated(){
        this.videoId=this.$route.query.id || '';
        if(this.videoId)this.loadTable();
    },
    
}
</script>
<style lang="less" scoped>
@import "@/assets/styles/public.less";

.page-onlinecourses-catalogue-editable {
  .page-content {
    width: 1200px;
    margin: 0 auto;
    .page_body {
      display: flex;
      margin-bottom: 70px;
    }
    .el-breadcrumb {
      margin-bottom: 20px;
    }

    .data-wrapper{
    display: block;
    width: 100%;
.video-wrapper {
    width: 100%;
    margin-bottom: 20px;
    iframe {
        height: 395px;
        width: 100%;
        border: none;
        background-color: #fff;
      }
}
.content-wrapper{
    width: 100%;
    background-color: white;
    border-radius: 5px;
    margin-bottom: 20px;
    .head-title{
        padding-left: 20px;
        height: 68px;
        line-height: 68px;
        background-image: url('../../assets/images/video/video_title_bg.png');
        align-items: center;
        span{
          font-size: 20px;
          color: #333333;
          font-weight: 580;
        }
        
    }
   
    .course-desc-list {
        font-size: 16px;
        line-height: 2.5;
          margin-left: 20px;
          list-style: none;

        .row-flex-prefix {
          display: inline-block;
          width: 138px;
          font-weight: 600;
          color: #333333;
          max-width: 5em;
          text-align-last: right
        }
        .row-flex-main {
          color: #666;
        }
       
      }
}
}
  }
}


</style>
